import { Action } from '@ngrx/store';
import { LoadPageAction } from '../../../pillar/common/actions/LoadPageAction';
import {LoadPagePayload} from "../../../pillar/common/actions/LoadPagePayload";

export const GET_PARAMETERS = '[Rule] Get Parameters';

export class GetParametersAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_PARAMETERS;

  constructor(public payload: LoadPagePayload) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/GetParametersAction.ts